/**
 * Created by Mikhail Menshenin on 30.07.2026
 */

cleverapps.override(cleverapps.Tool.game, {
    "show inflate boundaries": {
        flag: "showInflateBoundaries"
    }
});

cleverapps.whenAllInitialized(function () {
    cleverapps.flags.on("change:showInflateBoundaries", InflateComponent.InflateGameField);
});
